// pages/LogoutCallback.jsx

import React, { useEffect } from "react";
import { oidcManager } from "../services/oauth/OAuthService";
import { useAuth } from "../hooks/useAuth";
import LoadingOverlay from "../components/loadingBar/LoadingOverlay";
import "./LogoutCallback.css";

const LogoutCallback = () => {
  const { postLogout } = useAuth();

  useEffect(() => {
    const runLogoutCallback = async () => {
      try {
        // Process the logout callback from the IdP
        await oidcManager.signoutRedirectCallback();

        // Clear app state (onboarding status is now persisted in database, not localStorage)
        localStorage.clear();
        sessionStorage.clear();

        // Call postLogout to reset user state
        postLogout();
        // Redirect to login or landing page
        window.location.href = "/";
      } catch (error) {
        window.location.href = "/"; // fallback even on failure
      }
    };

    runLogoutCallback();
  }, [postLogout]);

  return (
    <div className="logout-page">
      <LoadingOverlay
        isVisible={true}
        showProgressBar={false}
        message="Logging you out..."
      />
    </div>
  );
};

export default LogoutCallback;
